import { SuccessStatus } from "../Status/SuccessStatus"
import { BadStatus } from "../Status/BadStatus"
import { BoxWrapper, GridWrapper } from "../Wrappers/Wrappers"
import { Text, Title } from "../units/Text"
import { FlexWrapper } from "../Wrappers/Wrappers"
import { DetailText } from "../units/Text"
import { CommissionViewProps } from "../../pages/ACBView/ACBView"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { hasPermission } from "../../roles/roles"
import { Loader } from "../units/Loader"


const noData = 'Нет данных'

export const ServiceInfo = (serialNumber:string,  commission: CommissionViewProps) => {
    const { user } = useSignedInContext()
    
    if (commission.data === null) {
        return (
            <Loader/>
        )
    } 
    return (
        <BoxWrapper p="p0">
            <BoxWrapper p="p2" bg="bg-primary" r="r15" style={{position: "sticky", top: "0rem", zIndex:"1000"}}>
                { !commission.data.is_commissioned ? (
                    <FlexWrapper alignItems="center">
                        <Text className="bold" size="xxl">Требует ввода в эскплуатацию</Text>
                        { hasPermission({role:user.role, resource:'Commission', action:'update'}) ? (
                            <DetailText bg="bg-secondary" p="p1" r="r10" color="light" className="bold" href={`/react/acb/${serialNumber}/update-commission`}>Заполнить данные</DetailText>
                        ) : (<></>) }
                    </FlexWrapper>
                    ) : (
                    <FlexWrapper alignItems="center">
                        <Text className="bold" size="xxl">Введен в эскплуатацию</Text>
                        <FlexWrapper className="narrow-gap">
                            <DetailText bg="bg-secondary" p="p1" r="r10" color="light" className="bold" href={`/react/acb/${serialNumber}/comission-update-comment`}>Обновить комментарий</DetailText>
                        </FlexWrapper>
                    </FlexWrapper>
                    ) }
            </BoxWrapper>
            <br />
            <Text size="lg" className="bold p1">Фото</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Избражение</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.image ? 'Выбрарно' : noData }</Text>
                        </BoxWrapper>
                        { commission.data.image ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Физические свойства</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Номинальное напряжение</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.voltage ? commission.data.voltage + ' В' : noData }</Text>
                        </BoxWrapper>
                        { commission.data.voltage ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Номинальная емкость</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.nominal_capacity ? commission.data.nominal_capacity + ' Ач' : noData }</Text>
                        </BoxWrapper>
                        { commission.data.nominal_capacity ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Вес</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.weight ? commission.data.weight + ' Кг' : noData }</Text>
                        </BoxWrapper>
                        { commission.data.weight ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Габаритные размеры</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.size ? commission.data.size : noData }</Text>
                        </BoxWrapper>
                        { commission.data.size ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Срок службы</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.cycle_capacity ? commission.data.cycle_capacity : noData }</Text>
                        </BoxWrapper>
                        { commission.data.cycle_capacity ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Исполнение</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение охлаждение</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.is_cooling_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение отопление</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.is_heating_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение по умолчанию</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.is_default_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>

                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Исполнение водоустойчевость</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.is_waterproof_activity ? "Да" : "Нет" }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>
            <br />
            <Text size="lg" className="bold p1">Прочее</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Артикул</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.sku ? commission.data.sku : noData }</Text>
                        </BoxWrapper>
                        { commission.data.sku ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип химии</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.chemistry ?  
                                (
                                    commission.data.chemistry_choices.find(choice => choice.value === commission?.data?.chemistry)?.label
                                ) : (
                                    noData
                                ) }
                            </Text>
                        </BoxWrapper>
                        { commission.data.chemistry ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип элементов</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.accumulator_element ? 
                                (
                                    commission.data.accumulator_element
                                ) : (
                                    noData
                                ) 
                            }</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_element ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Код партии элементов</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.batch_code ? commission.data.batch_code : noData }</Text>
                        </BoxWrapper>
                        { commission.data.batch_code ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Серия АКБ</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_model_name ? (
                                    commission.data.accumulator_model_name
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_model_name ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Тип контакторов</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_contactor ? (
                                    commission.data.accumulator_contactor
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_contactor ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Доп. оборудование</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_additional_equipment ? (
                                    commission.data.accumulator_additional_equipment
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_additional_equipment ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Разъем разряда</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_discharge_connector ? (
                                    commission.data.accumulator_discharge_connector
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_discharge_connector ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Разъем заряда</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_charge_connector ? (
                                    commission.data.accumulator_charge_connector
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_charge_connector ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Датчик тока</Text>
                            <Text isBlock={true} color="secondary">{ 
                                commission.data.accumulator_current_sensor ? (
                                    commission.data.accumulator_current_sensor
                                ) : (
                                    noData
                            )}</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_current_sensor ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                {/* TODO
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия прошивки BMS (SW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.cycle_capacity ? commission.data.cycle_capacity : noData }</Text>
                        </BoxWrapper>
                        <SuccessStatus/>
                    </FlexWrapper>
                </BoxWrapper> */}
            </GridWrapper>
            <br/>
            <Text size="lg" className="bold p1">BMS</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Модель BMS</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.accumulator_bms_model ? commission.data.accumulator_bms_model : noData }</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_bms_model ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия платы BMS (HW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.bms_hw_version ? commission.data.bms_hw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.data.bms_hw_version ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия платы BMS (FW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.bms_fw_version ? commission.data.bms_fw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.data.bms_fw_version ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

            <br/>
            <Text size="lg" className="bold p1">Внешний пульт</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Внешний пульт</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.accumulator_external_remote_control ? commission.data.accumulator_external_remote_control : noData }</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_external_remote_control ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия платы внешнего пульта (HW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.accumulator_external_remote_control_hw_version ? commission.data.accumulator_external_remote_control_hw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_external_remote_control_hw_version ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Версия платы внешнего пульта (FW)</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.accumulator_external_remote_control_fw_version ? commission.data.accumulator_external_remote_control_fw_version : noData }</Text>
                        </BoxWrapper>
                        { commission.data.accumulator_external_remote_control_fw_version ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

            <br />
            <Text size="lg" className="bold p1">Администация</Text>
            <GridWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Ответственный за ввод карточки АКБ</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.responsible?.full_name ? commission.data.responsible.full_name : noData }</Text>
                        </BoxWrapper>
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Комментарий</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.comment ? commission.data.comment : noData }</Text>
                        </BoxWrapper>
                        { commission.data.comment ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Дата прохождения инициализации</Text>
                            <Text isBlock={true} color="secondary">{ commission.data.created_at ? new Date(commission.data.created_at).toLocaleString('sv-SE', { timeZone: 'Europe/Moscow' }).replace('T', ' ') : noData }</Text>
                        </BoxWrapper>
                        { commission.data.created_at ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
                <BoxWrapper bg="bg-primary" r="r15">
                    <FlexWrapper>
                        <BoxWrapper p="p0">
                            <Text className="bold">Конструкторская документация</Text>
                            {/* ${process.env.REACT_APP_DJANGO_SERVER_URL}/ */}
                            <Text isBlock={true} color="secondary">{ commission.data.documentation ? <DetailText href={`${commission.data.documentation}` }>Просмотр</DetailText>: noData }</Text>
                        </BoxWrapper>
                        { commission.data.documentation ? <SuccessStatus/> : <BadStatus/> }
                    </FlexWrapper>
                </BoxWrapper>
            </GridWrapper>

        </BoxWrapper>
    )
}